const INFO = {
	main: {
		title: "Jessie's Portfolio",
		name: "Jessie Sun",
		email: "rongsun0509@gmail.com",
		logo: "../logo.png",
	},

	socials: {
		twitter: "https://twitter.com/",
		github: "https://github.com/jessie-sr",
		linkedin: "https://www.linkedin.com/in/rongsun-jessie",
		instagram: "https://www.instagram.com/jessi_esr/",
		stackoverflow: "https://stackoverflow.com/users/22974262/jessie-sr",
		facebook: "https://facebook.com/",
	},

	homepage: {
		title: "I’m Jessie Sun, I code, create, and innovate.",
		description: [
        	"Hey there 👋 I’m Jessie, a 1st year master student studying Computer and Information Technology at Upenn. Prior to my graduate studies, I learned Computer Science at UC Berkeley 👩🏻‍💻. ",
			"I enjoy building scalable software solutions. I have experience developing RESTful APIs and data processing pipeline for PepsiCo and Coca-Cola 🥤.",
			"I'm passionate about innovation. I have a startup project on the automation technology of video 🎥 production.",
        	"Beyond the keyboard, you might find me smashing birdies on the badminton 🏸 court or sketching 🎨 out a new idea :)"
    	],
	},

	about: {
		title: "About me 👩🏻‍💻",
		description: [
			"Starting off in the world of business, my encounter with computer science at UC Berkeley left me irresistibly drawn to the art of coding. There’s something incredibly satisfying about designing and building sophisticated software systems—transforming lines of code into solutions that make a real-world impact. ",
			"Now, as a CS master's student, I’m passionate about blending my business acumen with technical prowess to craft innovative, intelligent systems that not only solve complex problems but also drive meaningful change. "
		]
	},

	jackotranslate: {
		title: "Navigating independent web app development: Jack 🎃 Translate",
		description:
			"\“Jack O Translate\" is a web application that supports translations between multiple languages. What makes it stand out is its ability to customize tone and context in translations, a feature often missing in standard translation tools but achieved here through integration with the OpenAI API. This project was my foray into independent webapp development, challenging me to come up with innovative software design and apply my programming skills in a real-world context."
	},

	articles: {
		title: "Join me on a journey where each story is a step towards a deeper understanding of both myself and the world around us.",
		description:
			"Chronological collection of my reflections on technology, leadership, software development, social changes and more. ",
	},

	projects: [
		{
			title: "Book Nest 📚",
			description:
				"A bookstore transaction management system built with Spring Boot, React and MySQL.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/java/java.png",
			linkText: "View Project",
			link: "https://github.com/jessie-sr/book-nest",
		},

		{
			title: "GenTune 🤖",
			description:
				"An A/B testing platform designed for optimizing AI-generated content implemented via NextJS.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/typescript/typescript.png",
			linkText: "View Project",
			link: "https://github.com/jessie-sr/prompteng",
		},

		{
			title: "Jack 🎃 Translate",
			description:
				"A GPT-based translation web-app developed with Ruby on Rails, Bootstrap and PostgreSQL.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/ruby/ruby.png",
			linkText: "View Project",
			link: "https://github.com/jessie-sr/jack-o-translate",
		},

		{
			title: "Pixelpulse Optimizer 🏎️",
			description:
				"A project focusing on boosting video processing algorithms through distributed computing.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/c/c.png",
			linkText: "View Project",
			link: "https://github.com/jessie-sr/pixelpulse-optimizer",
		},

		{
			title: "Dine 🍽️ Manager",
			description:
				"A comprehensive restaurant information management system built with Django and MySQL.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/python/python.png",
			linkText: "View Project",
			link: "https://github.com/jessie-sr/restaurant",
		},

		{
			title: "Gitlet 🕹️",
			description:
				"A minimalistic version control system that implements the core functionalities of Git.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/java/java.png",
			linkText: "View Project",
			link: "https://github.com/jessie-sr/gitlet",
		},
		
		{
			title: "Random World 🗺️",
			description:
				"A 2D tile-based world exploration game engine that features pseudorandomly generated rooms and hallways.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/java/java.png",
			linkText: "View Project",
			link: "https://github.com/jessie-sr/random-world",
		},

		{
			title: "SSSnake 🐍 Game",
			description:
				"Classic snake game made in C, where the player controls a snake to eat fruits and avoid crashing into walls or itself.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/c/c.png",
			linkText: "View Project",
			link: "https://github.com/jessie-sr/snake-game",
		},

		{
			title: "Scheme Interpreter",
			description:
				"A minimalistic interpreter for the Scheme programming language written in Python.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/python/python.png",
			linkText: "View Project",
			link: "https://github.com/jessie-sr/scheme-interpreter",
		},
	],
};

export default INFO;
